import { useState, useEffect } from 'react';
import mosqueService from '../services/mosqueService';

/**
 * Fetch a single mosque by URL segment (slug preferred; numeric id still supported by API).
 */
function useMosqueDetail(slugOrId) {
  const [mosque, setMosque] = useState(null);
  const [loading, setLoading] = useState(!!slugOrId);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slugOrId) {
      setMosque(null);
      setLoading(false);
      setError(null);
      return undefined;
    }

    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await mosqueService.getMosque(slugOrId);
        if (!cancelled) {
          setMosque(data);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err);
          setMosque(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [slugOrId]);

  return { mosque, loading, error };
}

export default useMosqueDetail;
